// extracted by mini-css-extract-plugin
export default {"track":"DnaHub_track__MI2vR","stage":"DnaHub_stage__Kb6kH","canvas":"DnaHub_canvas__I5FHw","headline":"DnaHub_headline__hbuit"};